import React from "react";
import StarRatings from "react-star-ratings";
import { useTranslation } from "react-i18next";
import { selectTextByLanguage, useGetAvailableTranslation } from "../../hooks/global/Languages";

function CriteriaStatistics(props) {
  const { t, i18n } = useTranslation();
  const reviewsStatistics = props.reviewsStatistics;
  const starColor = "#f8bf2a";
  const numStars = 5;
  const availableLanguages = useGetAvailableTranslation();

  const renderStats = (reviewsStatistics) => {
    return Object.values(reviewsStatistics).map((stat, index) => {
      return (
        <div className="item" key={index}>
          <div className="stars rate starsPodrobnaOcena">
            <StarRatings
              rating={parseFloat(stat.score)}
              starRatedColor={starColor}
              name="rating"
              numberOfStars={numStars}
              starDimension={'16'}
              starSpacing={'1'}
            />
          </div>
          <div className="grade">
            <span>
              {stat.score}
              <sup>/5</sup>
            </span>
          </div>
          <p className="criteria">{selectTextByLanguage(stat.name, i18n.language, availableLanguages)}</p>
        </div>
      );
    });
  };
  return (
    <div>
      <section className="criteriaStatistics">
        <h3>{t("admin.cert.detRev")}</h3>
        <div>{reviewsStatistics && renderStats(reviewsStatistics)}</div>
      </section>
    </div>
  );
}

export default CriteriaStatistics;
